import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-heading">Pages</h3>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="#">Products</a></li>
            <li><a href="/research">Research</a></li>
            <li><a href="#">About</a></li>
            <li><a href="https://docs.assistantslab.org/" target="_blank" rel="noopener noreferrer">Docs</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3 className="footer-heading">Socials</h3>
          <ul className="footer-links social-links">
            <li>
              <a href="https://huggingface.co/AssistantsLab" target="_blank" rel="noopener noreferrer">
                <svg className="social-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.945 0C5.346 0 0 5.346 0 11.945 0 18.544 5.346 23.889 11.945 23.889 18.544 23.889 23.889 18.544 23.889 11.945 23.889 5.346 18.544 0 11.945 0Z" fill="currentColor" />
                  <path d="M5.006 12.516c0-.803.65-1.454 1.452-1.454.804 0 1.454.65 1.454 1.454 0 .803-.65 1.453-1.454 1.453-.803 0-1.452-.65-1.452-1.453zM15.977 12.516c0-.803.65-1.454 1.454-1.454.803 0 1.452.65 1.452 1.454 0 .803-.65 1.453-1.452 1.453-.804 0-1.454-.65-1.454-1.453z" fill="#fff" />
                  <path d="M15.56 15.725c-.355 0-.71.142-.964.425a4.129 4.129 0 0 1-5.304 0 1.361 1.361 0 0 0-1.928 0 1.36 1.36 0 0 0 0 1.928 6.852 6.852 0 0 0 8.16 1.284 6.852 6.852 0 0 0 1 .142c.355 0 .71-.142.964-.425a1.361 1.361 0 0 0 0-1.929c-.254-.283-.61-.425-.964-.425h.035z" fill="#fff" />
                </svg>
                Huggingface
              </a>
            </li>
            <li>
              <a href="https://github.com/AssistantsLab" target="_blank" rel="noopener noreferrer">
                <svg className="social-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z" fill="currentColor" />
                </svg>
                GitHub
              </a>
            </li>
            <li>
              <a href="https://discord.gg/45MHwt5rBM" target="_blank" rel="noopener noreferrer">
                <svg className="social-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.317 4.492c-1.53-.69-3.17-1.2-4.885-1.49a.075.075 0 0 0-.079.036c-.21.393-.445.904-.608 1.306a17.98 17.98 0 0 0-5.487 0 12.608 12.608 0 0 0-.617-1.306.077.077 0 0 0-.079-.036c-1.714.29-3.354.8-4.885 1.491a.07.07 0 0 0-.032.027C.533 9.093-.32 13.555.099 17.961a.08.08 0 0 0 .031.055 20.03 20.03 0 0 0 5.993 2.98.078.078 0 0 0 .084-.026c.462-.62.874-1.275 1.226-1.963.021-.04.001-.088-.041-.104a13.201 13.201 0 0 1-1.872-.878.075.075 0 0 1-.008-.125c.126-.093.252-.19.372-.287a.075.075 0 0 1 .078-.01c3.927 1.764 8.18 1.764 12.061 0a.075.075 0 0 1 .079.009c.12.098.245.195.372.288a.075.075 0 0 1-.006.125c-.598.344-1.22.635-1.873.877a.075.075 0 0 0-.041.105c.36.687.772 1.341 1.225 1.962a.077.077 0 0 0 .084.028 19.963 19.963 0 0 0 6.002-2.981.076.076 0 0 0 .032-.054c.5-5.094-.838-9.52-3.549-13.442a.06.06 0 0 0-.031-.028zM8.02 15.278c-1.182 0-2.157-1.069-2.157-2.38 0-1.312.956-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.956 2.38-2.157 2.38zm7.975 0c-1.183 0-2.157-1.069-2.157-2.38 0-1.312.955-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.946 2.38-2.157 2.38z" fill="currentColor" />
                </svg>
                Discord
              </a>
            </li>
          </ul>
        </div>
        
        <div className="footer-section logo-section">
          <img 
            src="/icons/logo.svg" 
            alt="AssistantsLab Logo" 
            className="footer-logo"
          />
          <p className="footer-tagline">
            Building the future of AI assistance
          </p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="copyright">
          <span>© {currentYear} AssistantsLab. All rights reserved.</span>
        </div>
        <div className="footer-bottom-links">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;